export default import.meta.ROLLUP_FILE_URL_CTa1WMbk